(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hh-image-marquee"] && !Shopify.designMode) return;
  try {
    
  /* HH FIX: OS 애니메이션 감소 환경에서만 마우스 좌우 드래그 활성화.
     모바일은 기본 터치 스와이프를 그대로 사용. 일반 환경의 자동 흐름은 수정하지 않음. */
  (() => {
    if (window.__hhImageMarqueeDragInstalled) return;
    window.__hhImageMarqueeDragInstalled = true;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const selector = '.hh-image-marquee__viewport';
    const initialized = new WeakSet();

    const accessibilityLabel = () => {
      const lang = (document.documentElement.lang || '').toLowerCase();
      if (lang.startsWith('ja')) return '取引先ロゴ。左右にスクロールできます';
      if (lang.startsWith('ko')) return '협업 브랜드 로고. 좌우로 스크롤할 수 있습니다';
      return 'Partner logos. Scroll horizontally to explore';
    };

    const updateAccessibility = () => {
      document.querySelectorAll(selector).forEach((viewport) => {
        if (!initialized.has(viewport)) return;
        if (reducedMotion.matches) {
          viewport.tabIndex = 0;
          viewport.setAttribute('role', 'group');
          viewport.setAttribute('aria-label', accessibilityLabel());
        } else {
          viewport.removeAttribute('tabindex');
          viewport.removeAttribute('role');
          viewport.removeAttribute('aria-label');
        }
      });
    };

    const attach = (viewport) => {
      if (initialized.has(viewport)) return;
      initialized.add(viewport);

      let pressed = false;
      let dragging = false;
      let suppressClick = false;
      let activePointerId = null;
      let startX = 0;
      let initialScrollLeft = 0;

      const finishDrag = (event) => {
        if (event && activePointerId !== event.pointerId) return;
        suppressClick = dragging;
        pressed = false;
        dragging = false;
        activePointerId = null;
        viewport.classList.remove('hh-marquee-is-dragging');
      };

      viewport.addEventListener('pointerdown', (event) => {
        if (!reducedMotion.matches || event.pointerType !== 'mouse' || event.button !== 0) return;
        pressed = true;
        dragging = false;
        suppressClick = false;
        activePointerId = event.pointerId;
        startX = event.clientX;
        initialScrollLeft = viewport.scrollLeft;
      });

      viewport.addEventListener('pointermove', (event) => {
        if (!pressed || event.pointerId !== activePointerId) return;
        if ((event.buttons & 1) === 0) {
          finishDrag(event);
          return;
        }
        const deltaX = event.clientX - startX;
        if (!dragging && Math.abs(deltaX) >= 6) {
          dragging = true;
          viewport.classList.add('hh-marquee-is-dragging');
          if (viewport.setPointerCapture) viewport.setPointerCapture(event.pointerId);
        }
        if (dragging) {
          event.preventDefault();
          viewport.scrollLeft = initialScrollLeft - deltaX;
        }
      });

      viewport.addEventListener('pointerup', finishDrag);
      viewport.addEventListener('pointercancel', finishDrag);
      viewport.addEventListener('lostpointercapture', () => {
        pressed = false;
        dragging = false;
        activePointerId = null;
        viewport.classList.remove('hh-marquee-is-dragging');
      });

      viewport.addEventListener('dragstart', (event) => {
        if (reducedMotion.matches) event.preventDefault();
      });

      viewport.addEventListener('click', (event) => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        suppressClick = false;
      }, true);
    };

    const init = (root = document) => {
      if (root.matches && root.matches(selector)) attach(root);
      if (root.querySelectorAll) root.querySelectorAll(selector).forEach(attach);
      updateAccessibility();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(), { once: true });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
    if (reducedMotion.addEventListener) {
      reducedMotion.addEventListener('change', updateAccessibility);
    } else if (reducedMotion.addListener) {
      reducedMotion.addListener(updateAccessibility);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["layered-slideshow"] && !Shopify.designMode) return;
  try {
    
  /*
   * HABBIHABBI Layered Slideshow - Autoplay
   *
   * PC / 모바일 자동 재생
   * 화면에 보일 때만 재생
   * 클릭 / 터치 시 자동 재생 정지
   */

  if (!window.__hhLayeredSlideshowAutoplayInstalled) {
    window.__hhLayeredSlideshowAutoplayInstalled = true;

    const SECTION_SELECTOR =
      '.hh-layered-autoplay';

    const COMPONENT_SELECTOR =
      'layered-slideshow-component';

    const stateMap =
      new WeakMap();

    const getTabs = (component) =>
      Array.from(
        component.querySelectorAll(
          '.layered-slideshow__tablist [role="tab"]'
        )
      );

    const getActiveIndex = (component) =>
      getTabs(component).findIndex(
        (tab) =>
          tab.getAttribute(
            'aria-selected'
          ) === 'true'
      );

    const autoplayEnabled = (section) =>
      section.dataset.hhAutoplay === 'true';

    const pauseOnInteraction = (section) =>
      section.dataset.hhPauseOnInteraction === 'true';

    const getInterval = (section) => {
      const seconds =
        Number.parseFloat(
          section.dataset.hhAutoplayInterval
        );

      const safeSeconds =
        Number.isFinite(seconds)
          ? seconds
          : 5;

      return Math.max(
        2,
        safeSeconds
      ) * 1000;
    };

    const clearTimer = (state) => {
      if (state.timer) {
        window.clearTimeout(
          state.timer
        );

        state.timer = null;
      }
    };

    const scheduleNext = (state) => {
      clearTimer(state);

      if (
        !state.section.isConnected ||
        !state.component.isConnected ||
        !autoplayEnabled(state.section) ||
        state.userPaused ||
        !state.inViewport ||
        document.hidden
      ) {
        return;
      }

      const tabs =
        getTabs(state.component);

      if (
        tabs.length < 2 ||
        typeof state.component.select !== 'function'
      ) {
        return;
      }

      state.timer =
        window.setTimeout(
          () => {
            if (
              !state.section.isConnected ||
              !state.component.isConnected ||
              state.userPaused ||
              document.hidden
            ) {
              clearTimer(state);
              return;
            }

            const currentIndex =
              getActiveIndex(
                state.component
              );

            const safeCurrentIndex =
              currentIndex >= 0
                ? currentIndex
                : 0;

            const nextIndex =
              (
                safeCurrentIndex + 1
              ) % tabs.length;

            state.component.select(
              nextIndex
            );

            scheduleNext(state);
          },

          getInterval(
            state.section
          )
        );
    };

    const pauseFromUser = (state) => {
      if (
        !pauseOnInteraction(
          state.section
        )
      ) {
        return;
      }

      state.userPaused = true;

      clearTimer(state);

      state.section.classList.add(
        'hh-autoplay-is-paused'
      );
    };

    const visibilityObserver =
      new IntersectionObserver(
        (entries) => {
          entries.forEach(
            (entry) => {
              const section =
                entry.target;

              const state =
                stateMap.get(section);

              if (!state) {
                return;
              }

              state.inViewport =
                entry.isIntersecting &&
                entry.intersectionRatio >= 0.25;

              if (
                state.inViewport
              ) {
                scheduleNext(state);
              } else {
                clearTimer(state);
              }
            }
          );
        },

        {
          threshold: [
            0,
            0.25,
            0.5
          ]
        }
      );

    const cleanupSection = (section) => {
      const state =
        stateMap.get(section);

      if (!state) {
        return;
      }

      clearTimer(state);

      visibilityObserver.unobserve(
        section
      );

      if (
        state.onPointerDown
      ) {
        state.component.removeEventListener(
          'pointerdown',
          state.onPointerDown,
          true
        );
      }

      if (
        state.onKeyDown
      ) {
        state.component.removeEventListener(
          'keydown',
          state.onKeyDown,
          true
        );
      }

      stateMap.delete(section);

      section.__hhLayeredAutoplayCleanup =
        null;
    };

    const initSection = (section) => {
      if (
        !(section instanceof Element)
      ) {
        return;
      }

      cleanupSection(section);

      const component =
        section.querySelector(
          COMPONENT_SELECTOR
        );

      if (!component) {
        return;
      }

      const tabs =
        getTabs(component);

      if (
        tabs.length < 2
      ) {
        return;
      }

      const state = {
        section,
        component,
        timer: null,
        inViewport: false,
        userPaused: false,
        onPointerDown: null,
        onKeyDown: null
      };

      /*
       * PC 마우스 클릭 + 모바일 터치
       * 모두 pointerdown으로 처리됩니다.
       *
       * preventDefault는 하지 않으므로
       * 기존 탭/링크 클릭은 그대로 동작합니다.
       */
      state.onPointerDown = () => {
        pauseFromUser(state);
      };

      state.onKeyDown = (event) => {
        if (
          event.key === 'Enter' ||
          event.key === ' ' ||
          event.key === 'ArrowLeft' ||
          event.key === 'ArrowRight'
        ) {
          pauseFromUser(state);
        }
      };

      component.addEventListener(
        'pointerdown',
        state.onPointerDown,
        true
      );

      component.addEventListener(
        'keydown',
        state.onKeyDown,
        true
      );

      stateMap.set(
        section,
        state
      );

      section.__hhLayeredAutoplayCleanup =
        () =>
          cleanupSection(section);

      visibilityObserver.observe(
        section
      );
    };

    const initAll = (
      root = document
    ) => {
      if (
        root.matches &&
        root.matches(
          SECTION_SELECTOR
        )
      ) {
        initSection(root);
      }

      if (
        root.querySelectorAll
      ) {
        root
          .querySelectorAll(
            SECTION_SELECTOR
          )
          .forEach(
            initSection
          );
      }
    };

    const rescheduleVisibleSections = () => {
      document
        .querySelectorAll(
          SECTION_SELECTOR
        )
        .forEach(
          (section) => {
            const state =
              stateMap.get(section);

            if (!state) {
              return;
            }

            if (
              document.hidden
            ) {
              clearTimer(state);
            } else if (
              state.inViewport
            ) {
              scheduleNext(state);
            }
          }
        );
    };

    if (
      document.readyState === 'loading'
    ) {
      document.addEventListener(
        'DOMContentLoaded',
        () => initAll(),
        {
          once: true
        }
      );
    } else {
      initAll();
    }

    document.addEventListener(
      'visibilitychange',
      rescheduleVisibleSections
    );

    /*
     * Shopify Theme Editor에서
     * 섹션이 다시 로드될 때 재초기화
     */
    document.addEventListener(
      'shopify:section:load',
      (event) => {
        initAll(event.target);
      }
    );

    document.addEventListener(
      'shopify:section:unload',
      (event) => {
        if (
          event.target
            ?.__hhLayeredAutoplayCleanup
        ) {
          event.target
            .__hhLayeredAutoplayCleanup();
        }

        event.target
          ?.querySelectorAll
          ?.(SECTION_SELECTOR)
          .forEach(
            (section) => {
              if (
                section
                  .__hhLayeredAutoplayCleanup
              ) {
                section
                  .__hhLayeredAutoplayCleanup();
              }
            }
          );
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
